import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import styled from 'styled-components'
import LoadIcon from '../../components/LoadIcon'
import config from '../../config'
import routes from '../../routes'
import Amplitude from '../../utils/amplitudeHelper'

const MobileLobby = ({ currentUser }) => {
  const [loading, setLoading] = useState(true)
  const history = useHistory()

  const routePath = {
    Auditorium: routes.auditorium1,
    Gallery: routes.onDemand,
  }

  useEffect(() => {
    Amplitude.visit('Lobby')
    Amplitude.visitTemp(`Lobby`)
  }, [currentUser.id])

  useEffect(() => {
    function callback(e) {
      if (e.data) {
        history.push(routePath[e.data])
      }
    }
    window.addEventListener('message', callback)

    return () => {
      window.removeEventListener('message', callback)
    }
  }, [])

  return (
    <Page>
      {loading && <LoadIcon />}
      <iframe
        style={{ height: '100vh', width: '100%', overflow: 'hidden', border: 'none' }}
        allowFullScreen={false}
        title="Lobby Tour"
        scrolling="no"
        src="/lobby-tour/index.htm"
        onLoad={() => {
          setLoading(false)
        }}
      />
    </Page>
  )
}

const Page = styled.div`
  /* background: url(${config.assets.lobby.portrait}); */
  background-size: cover;
  background-position: center;
  height: calc(100% - 60px);
  width: 100vw;
  overflow: hidden;
  position: absolute;
  #organiser-container {
    width: 60%;
    display: flex;
    margin: 8px 36px;
    color: #fff;
    font-size: 10px;
    div {
      width: 20%;
      margin-left: 10px;
    }
  }
  #event-container {
    width: 85%;
    margin: 0 auto;
    #event-name {
      filter: brightness(0) invert(1);
    }
  }
  .living {
    width: 150px;
    position: absolute;
    top: 12%;
    left: 50%;
    transform: translateX(-50%);
  }
  .menu {
    width: 100%;
    height: 220px;
    position: absolute;
    bottom: 0%;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
    background: white;
    border-radius: 20px 20px 0px 0px;
  }
  .title {
    font-size: 16px;
    font-weight: bold;
    font-style: italic;
    position: absolute;
    top: 15px;
    left: 15px;
  }
  .btn-container {
    display: flex;
    position: absolute;
    top: 17px;
    right: 20px;
  }
  .mute-button,
  .logout-button {
    width: 80px;
    height: 22px;
    display: flex;
    align-items: center;
  }
  .mute-icon {
    height: 15px;
    margin-right: 3px;
  }
  .logout-icon {
    height: 15px;
  }
  .mute-label,
  .logout-label {
    font-size: 12px;
    margin: 0;
  }
  .logout-label {
    color: #002060;
  }
  .list-wrapper {
    width: 100%;
    height: 160px;
    position: absolute;
    top: 50px;
    left: 0;
    overflow-x: scroll;
    display: flex;
    align-items: center;
  }
  .item-box {
    width: 130px;
    height: 160px;
    margin-left: 20px;
    border: solid 3px #134068;
    border-radius: 10px;
    background: white;
    flex-shrink: 0;
    box-sizing: border-box;
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }
  .icon-wrapper {
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .item-label {
    font-size: 11px;
    font-weight: bold;
    text-align: center;
    color: #272727;
    margin: 0px;
  }
  .item-button {
    background-color: #002f62;
    color: white;
    border: none;
    border-radius: 30px;
    font-size: 12px;
    font-weight: bold;
    width: 90px;
    height: 25px;
    margin: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .meeting1 {
    width: 135%;
    transform: translateY(15%);
  }
  .meeting2 {
    width: 85%;
  }
  .meeting {
    width: 150%;
  }
  .expo {
    width: 170%;
  }
  .gallerium {
    width: 140%;
  }
  .networking {
    width: 110%;
  }
  @media screen and (min-width: 540px) {
    .video-wrapper {
      width: 500px;
      height: 281.25px;
      padding-bottom: 0;
      position: absolute;
      /*top: 30%;*/
      bottom: 230px;
      left: 50%;
      transform: translateX(-50%);
    }
    .menu {
      height: 275px;
    }
    .list-wrapper {
      top: 65px;
    }
    .logo {
      width: 50%;
      margin: 100px auto;
    }
  }
`

export default MobileLobby
